// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.container[data-v-f57cb8a4] {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
button[data-v-f57cb8a4] {
  background-color: #007bff;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  margin: 10px 0;
}
button[data-v-f57cb8a4]:hover {
  background-color: #0056b3;
}
button[data-v-f57cb8a4]:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
.result[data-v-f57cb8a4], .error[data-v-f57cb8a4] {
  margin-top: 20px;
  padding: 15px;
  border-radius: 5px;
}
.result[data-v-f57cb8a4] {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}
.error[data-v-f57cb8a4] {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}
pre[data-v-f57cb8a4] {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 5px;
  padding: 15px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/views/TestApi.vue"],"names":[],"mappings":";AAiDA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB","sourcesContent":["<template>\r\n  <div class=\"container\">\r\n    <h1>API 测试页面</h1>\r\n    <button @click=\"testApi\" :disabled=\"loading\">测试后端连接</button>\r\n    <div class=\"result\" v-if=\"result\">\r\n      <h3>测试结果:</h3>\r\n      <pre>{{ result }}</pre>\r\n    </div>\r\n    <div class=\"error\" v-if=\"error\">\r\n      <h3>错误信息:</h3>\r\n      <pre>{{ error }}</pre>\r\n    </div>\r\n  </div>\r\n</template>\r\n\r\n<script>\r\nimport api from '@/services/api';\r\n\r\nexport default {\r\n  name: 'TestApi',\r\n  data() {\r\n    return {\r\n      loading: false,\r\n      result: null,\r\n      error: null\r\n    };\r\n  },\r\n  methods: {\r\n    async testApi() {\r\n      this.loading = true;\r\n      this.result = null;\r\n      this.error = null;\r\n      \r\n      try {\r\n        // 测试客户端检测 API\r\n        const response = await api.get('/yisheng/detect-client');\r\n        this.result = JSON.stringify(response.data, null, 2);\r\n      } catch (err) {\r\n        console.error('API 测试失败:', err);\r\n        this.error = err.message || '未知错误';\r\n      } finally {\r\n        this.loading = false;\r\n      }\r\n    }\r\n  }\r\n};\r\n</script>\r\n\r\n<style scoped>\r\n.container {\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n}\r\nbutton {\r\n  background-color: #007bff;\r\n  color: white;\r\n  padding: 12px 20px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  width: 100%;\r\n  margin: 10px 0;\r\n}\r\nbutton:hover {\r\n  background-color: #0056b3;\r\n}\r\nbutton:disabled {\r\n  background-color: #cccccc;\r\n  cursor: not-allowed;\r\n}\r\n.result, .error {\r\n  margin-top: 20px;\r\n  padding: 15px;\r\n  border-radius: 5px;\r\n}\r\n.result {\r\n  background-color: #d4edda;\r\n  color: #155724;\r\n  border: 1px solid #c3e6cb;\r\n}\r\n.error {\r\n  background-color: #f8d7da;\r\n  color: #721c24;\r\n  border: 1px solid #f5c6cb;\r\n}\r\npre {\r\n  background-color: #f8f9fa;\r\n  border: 1px solid #e9ecef;\r\n  border-radius: 5px;\r\n  padding: 15px;\r\n  overflow-x: auto;\r\n  white-space: pre-wrap;\r\n  word-wrap: break-word;\r\n}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
